import React from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { MessageCircle } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
import { ActionGroup, CountSpan } from '../SocialActions.styles';
import { formatNumber, getButtonSize } from '../utils';
export var CommentButton = function(param) {
    var repliesCount = param.repliesCount, onComment = param.onComment, size = param.size, showCounts = param.showCounts, labels = param.labels;
    return /*#__PURE__*/ React.createElement(ActionGroup, {
        onClick: function(e) {
            return e.stopPropagation();
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        iconOnly: true,
        size: getButtonSize(size),
        variant: "ghost",
        icon: /*#__PURE__*/ React.createElement(MessageCircle, {
            strokeWidth: 2
        }),
        onClick: onComment,
        label: labels.comment || '답글',
        className: "border-0 text-gray-500 hover:text-blue-500 dark:text-gray-300 dark:hover:text-blue-400",
        animation: "none"
    }), showCounts && repliesCount > 0 && /*#__PURE__*/ React.createElement(CountSpan, null, formatNumber(repliesCount)));
};
